







































































































































import Vue from 'vue';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import { PageBanner, PageSidebar } from '@/components/page-components';
import { SalesforceChat } from '@/components/global-components';
import {
  MemberCustomerServiceInfoResponseModel,
  Address,
} from '@/@types/member';

interface Data {
  sidebarHeading: string;
  sidebarContent: string;
  phoneContent: string;
  hoursContent: string;
  mailContent: string;
  emailContent: string;
  faxContent: string;
}

export default Vue.extend({
  name: 'ContactUs',
  beforeRouteEnter(to, from, next) {
    const promises = [store.dispatch('getMemberCustomerServiceInformation')];
    LoadingService.watchPromises(promises)
      .then(() => {
        getSidebarContent()
          .then((data) => {
            const contentAreas = data[0];
            if (contentAreas) {
              if (contentAreas[0] && contentAreas[0].fields) {
                to.meta.sidebarHeading = contentAreas[0].fields.headline;
                to.meta.sidebarContent = contentAreas[0].fields.content;
              }
            }
            next();
          })
          .catch(showErrorModal);
      })
      .catch(() => {
        getFallbackContent()
          .then((data) => {
            const contentAreas = data[0];
            if (contentAreas) {
              if (contentAreas[0] && contentAreas[0].fields) {
                to.meta.phoneContent = contentAreas[0].fields.content;
              }
              if (contentAreas[1] && contentAreas[1].fields) {
                to.meta.hoursContent = contentAreas[1].fields.content;
              }
              if (contentAreas[2] && contentAreas[2].fields) {
                to.meta.mailContent = contentAreas[2].fields.content;
              }
              if (contentAreas[3] && contentAreas[3].fields) {
                to.meta.emailContent = contentAreas[3].fields.content;
              }
              if (contentAreas[4] && contentAreas[4].fields) {
                to.meta.faxContent = contentAreas[4].fields.content;
              }
            }
            next();
          })
          .catch(showErrorModal);
      });

    function getSidebarContent() {
      const sidebarContentPromises = [
        getContentArea(['contact-us-sidebar-content']),
      ];
      return LoadingService.watchPromises(sidebarContentPromises);
    }

    function getFallbackContent() {
      const fallbackContentPromises = [
        getContentArea([
          'contact-us-phone',
          'contact-us-hours',
          'contact-us-mail',
          'contact-us-email',
          'contact-us-fax',
        ]),
      ];
      return LoadingService.watchPromises(fallbackContentPromises);
    }

    function showErrorModal() {
      EventBus.$emit('openModal', 'Error', {
        message: 'global_connection-error',
        action: {
          label: 'global_try-again',
          performAction() {
            location.reload();
          },
        },
        hideCancel: true,
      });
      EventBus.$emit('initialLoadDone');
    }
  },
  data(): Data {
    return {
      sidebarHeading: this.$route.meta.sidebarHeading,
      sidebarContent: this.$route.meta.sidebarContent,
      phoneContent: this.$route.meta.phoneContent || '',
      hoursContent: this.$route.meta.hoursContent || '',
      mailContent: this.$route.meta.mailContent || '',
      emailContent: this.$route.meta.emailContent || '',
      faxContent: this.$route.meta.faxContent || '',
    };
  },
  computed: {
    customerServiceInfo(): MemberCustomerServiceInfoResponseModel {
      return this.$store.getters.customerServiceInformation;
    },
    hasCustomerServiceInfo(): boolean {
      return !(
        Object.keys(this.customerServiceInfo).length === 0 &&
        this.customerServiceInfo.constructor === Object
      );
    },
    address(): Address {
      return this.customerServiceInfo.address;
    },
    showPhoneInfo(): boolean {
      return (
        !!(
          this.hasCustomerServiceInfo && !!this.customerServiceInfo.phoneNumber
        ) || !!(!this.hasCustomerServiceInfo && this.phoneContent)
      );
    },
    showHoursInfo(): boolean {
      return (
        !!(this.hasCustomerServiceInfo && this.customerServiceInfo.hours) ||
        !!(!this.hasCustomerServiceInfo && this.hoursContent)
      );
    },
    showAddressInfo(): boolean {
      return (
        !!(this.hasCustomerServiceInfo && this.address) ||
        !!(!this.hasCustomerServiceInfo && this.mailContent)
      );
    },
    showEmailInfo(): boolean {
      return (
        !!(
          this.hasCustomerServiceInfo && this.customerServiceInfo.emailMessage
        ) || !!(!this.hasCustomerServiceInfo && this.emailContent)
      );
    },
    showFaxInfo(): boolean {
      return (
        !!(
          this.hasCustomerServiceInfo && !!this.customerServiceInfo.faxNumber
        ) || !!(!this.hasCustomerServiceInfo && this.faxContent)
      );
    },
  },
  components: {
    PageBanner,
    PageSidebar,
    SalesforceChat,
  },
});
